import { isErrorResponse, getErrorFromErrorResponse } from '@standardnotes/responses';
import { Result, SharedVaultUserPermission } from '@standardnotes/domain-core';
export class SendVaultInvite {
    constructor(vaultInvitesServer) {
        this.vaultInvitesServer = vaultInvitesServer;
    }
    async execute(params) {
        const permissionOrError = SharedVaultUserPermission.create(params.permission);
        if (permissionOrError.isFailed()) {
            return Result.fail(permissionOrError.getError());
        }
        const permission = permissionOrError.getValue();
        const response = await this.vaultInvitesServer.createInvite({
            sharedVaultUuid: params.sharedVaultUuid,
            recipientUuid: params.recipientUuid,
            encryptedMessage: params.encryptedMessage,
            permission: permission,
        });
        if (isErrorResponse(response)) {
            return Result.fail(getErrorFromErrorResponse(response).message);
        }
        return Result.ok(response.data.invite);
    }
}
